<template>
  <div class="receipt-view-single">
    <div class="content-view-container">
      <div class="page-title">焦作市工程建设领域农民工工资保证金存储通知书</div>
      <div class="page-main">
        <div class="main-table-col">
          <div class="first-line">
            <div>编号：{{model.orderNumber}}</div>
            <div>日期：{{$moment(model.createTime).format('YYYY-MM-DD')}}</div>
            <div>NO.：{{model.serialNo}}</div>
          </div>
          <div class="table-wrapper">
            <table cellpadding="0" cellspacing="0" border="1" width="100%">
              <colgroup>
                <col width="10%" />
                <col />
                <col width="10%" />
                <col />
                <col width="10%" />
                <col width="10%" />
                <col width="7%" />
                <col width="10%" />
              </colgroup>
              <tr>
                <td align="center"><b>工程名称</b></td>
                <td>{{ model.projectName }}</td>
                <td align="center"><b>建设单位</b></td>
                <td>{{ model.ownerName }}</td>
                <td align="center"><b>负责人</b></td>
                <td>{{ model.ownerManager }}</td>
                <td align="center"><b>电话</b></td>
                <td>{{ model.ownerManagerTel }}</td>
              </tr>
              <tr>
                <td align="center" rowspan="2"><span><b>工程地址</b></span></td>
                <td rowspan="2"><span>{{ model.projectSite }}</span></td>
                <td align="center" rowspan="2"><span><b>施工<br>总承包单位</b></span></td>
                <td rowspan="2"><span>{{ model.contractorName }}</span></td>
                <td align="center"><b>项目经理</b></td>
                <td>{{ model.contractorManager }}</td>
                <td align="center"><b>电话</b></td>
                <td>{{ model.contractorManagerTel }}</td>
              </tr>
              <tr>
                <td align="center"><b>保证金经办人</b></td>
                <td>{{ model.opName }}</td>
                <td align="center"><b>电话</b></td>
                <td>{{ model.opTel }}</td>
              </tr>
              <tr>
                <td align="center"><b>结构形式</b></td>
                <td>{{ model.projectStruc }}</td>
                <td align="center"><b>中标价(元)</b></td>
                <td>{{ model.projectCost }}</td>
                <td align="center"><b>招标规模</b></td>
                <td>{{ model.projectScale }}</td>
                <td align="center"><b>工期</b></td>
                <td>{{ $moment(model.projectStartDate).format('YYYY-MM-DD') }} 至 {{ $moment(model.projectEndDate).format('YYYY-MM-DD') }}</td>
              </tr>
              <tr>
                <td align="center" colspan="3"><b>存储方式</b></td>
                <td align="center"><b>存储基数（中标价）</b></td>
                <td align="center"><b>存储比例 (%)</b></td>
                <td align="center" colspan="3"><b>应存储金额</b></td>
              </tr>
              <tr>
                <td colspan="3" class="even-td">
                  <div class="even-col">
                    <span style="width:50%">
                      现金 {{model.method === 0 ? '□' : '■'}}
                    </span>
                    <span style="width:50%">
                      保函 {{model.method === 1 ? '□' : '■'}}
                    </span>
                  </div>
                </td>
                <td>{{ model.projectCost }}</td>
                <td>{{ model.payableRatio }}</td>
                <td colspan="3" class="even-td">
                  <div class="even-col">
                    <span style="width:12.5%">千</span>
                    <span style="width:12.5%">百</span>
                    <span style="width:12.5%">十</span>
                    <span style="width:12.5%">万</span>
                    <span style="width:12.5%">千</span>
                    <span style="width:12.5%">百</span>
                    <span style="width:12.5%">十</span>
                    <span style="width:12.5%">元</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td align="center"><b>应存储金额</b></td>
                <td colspan="4">（大写）{{$common.transformNumberIntoCHS(model.payableAmount)}}</td>
                <td colspan="3" class="even-td">
                  <div class="even-col">
                    <span style="width:12.5%">{{ digits.d9 }}</span>
                    <span style="width:12.5%">{{ digits.d8 }}</span>
                    <span style="width:12.5%">{{ digits.d7 }}</span>
                    <span style="width:12.5%">{{ digits.d6 }}</span>
                    <span style="width:12.5%">{{ digits.d5 }}</span>
                    <span style="width:12.5%">{{ digits.d4}}</span>
                    <span style="width:12.5%">{{ digits.d3 }}</span>
                    <span style="width:12.5%">{{ digits.d2 }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td align="center" rowspan="2"><span><b>保证金<br>监管方</b></span></td>
                <td colspan="2" rowspan="2"><span>{{ model.supervisorName }}</span></td>
                <td align="center"><b>经办机构名称</b></td>
                <td colspan="2">{{ model.guarantorName }}</td>
                <td align="center"><b>联系人</b></td>
                <td>{{ model.guarantorContact }}</td>
              </tr>
              <tr>
                <td align="center"><b>经办机构地址</b></td>
                <td colspan="2">{{ model.guarantorAddress }}</td>
                <td align="center"><b>电话</b></td>
                <td>{{ model.guarantorTel }}</td>
              </tr>
              <tr>
                <td colspan="4" class="desc">
                  <p>农民工工资保证金由施工总承包单位 (包括直接承包建设单位发包工程的专业承包企业)到焦作市农民工工资保证金经办机构存储，存储方式为现金或保函。存储单位应当自取得施工许可证之日起 20个工作日内完成农民工工资保证金存储，同时将此通知书报{{agentName}}备案。妥善保管留存联，退还或解除保函时提交。</p>
                  <p>存储单位未按规定办理存储农民工工资保证金的，由属地人社部门依据《保障农民工工资支付条例》第五十五条规定给予行政处罚 (处理)，并列入其信用记录，依法实施联合惩戒。</p>
                  <p>农民工工资保证金由属地人社部门监管，专项用于解决拖欠工资问题。工程竣工备案后，符合退还条件并经核实无拖欠工资行为的，监管方依法开具退还或解除保函手续，本通知书收回。</p>
                </td>
                <td colspan="2">
                  <p>&nbsp;<br></p>
                  <p>&nbsp;<br></p>
                  <p>{{ stampName }}:</p>
                  <p>&nbsp;<br></p>
                  <p>&nbsp;<br></p>
                  <p>&nbsp;<br></p>
                  <p>经办人:</p>
                  <p>&nbsp;<br></p>
                  <p>&nbsp;<br></p>
                </td>
                <td colspan="2">
                  <p>&nbsp;<br></p>
                  <p>&nbsp;<br></p>
                  <p>经办机构 (单位公章):</p>
                  <p>&nbsp;<br></p>
                  <p>&nbsp;<br></p>
                  <p>&nbsp;<br></p>
                  <p>经办人（章）:</p>
                  <p>&nbsp;<br></p>
                  <p>&nbsp;<br></p>
                </td>
              </tr>
            </table>
          </div>
          <div class="last-line">
            <div>现金存储或开具保函日期:</div>
            <div class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
            <div>经办机构办结日期:</div>
            <div class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
          </div>
        </div>
        <div class="main-seq-col">
          <div>{{ copyName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'project-register-receipt-view',
  components: {
  },
  props: {
    copyName: {
      type: String,
      default: () => '第一联 监管单位留存'
    },
    agentName: {
      type: String,
      default: () => ''
    },
    stampName: {
      type: String,
      default: () => ''
    },
    model: {
      type: Object,
      default: () => {
        return {
          industryId: null,
          cityId: null,
          method: 0, // 存储方式：0-保函|1-现金
          projectName: null,
          projectSite: null,
          projectStruc: null,
          projectScale: null,
          projectCost: 0,
          projectStartDate: null,
          projectEndDate: null,
          daterange: null,
          duration: null,
          ownerName: null,
          ownerManager: null,
          ownerManagerTel: null,
          contractorName: null,
          contractorManager: null,
          contractorManagerTel: null,
          payableBase: 0,
          payableAmount: 0,
          payableRatio: 2,
          opName: null,
          opTel: null,
          supervisorName: null,
          guarantorName: null,
          guarantorAddress: null,
          guarantorContact: null,
          guarantorTel: null,
        }
      }
    }
  },
  watch: {
    'model.payableAmount': function (newVal) {
      console.log(newVal)
      this.procDigits(newVal)
    }
  },
  data () {
    return {
      contentHtml: null,
      digits: {
        d0: '',
        d1: '',
        d2: '',
        d3: '',
        d4: '',
        d5: '',
        d6: '',
        d7: '',
        d8: '',
        d9: ''
      }
    }
  },
  mounted () {
    this.procDigits(this.model.payableAmount)
  },
  methods: {
    procDigits (amount) {
      // console.log(amount, typeof(amount), typeof(amount) === 'number')
      if (typeof(amount) === 'number') {
        amount = Math.round(amount) * 100
        let amtStrArr = Array.from(amount.toString())
        // console.log(amount, amtStrArr)
        for (let i = amtStrArr.length - 1; i >= 0; i--) {
          this.digits['d' + (amtStrArr.length - 1 - i)] = amtStrArr[i]
        }
        // console.log(this.digits)
      } else {
        this.digits = {
          d0: '',
          d1: '',
          d2: '',
          d3: '',
          d4: '',
          d5: '',
          d6: '',
          d7: '',
          d8: '',
          d9: ''
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.receipt-view-single {
  page-break-after: always;
}
.content-view-container {
  display: flex;
  flex-direction: column;
  .page-title {
    text-align: center;
    font-size: 8mm;
    font-weight: bold;
  }
  .page-main {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    .main-seq-col {
      width: 18px;
      padding: 10px;
      font-size: 3mm;
      align-items: center;
      justify-content: center;
      text-align: center;
      display: flex;
    }
    .main-table-col {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      .first-line {
        padding: 10px 0;
        font-size: 3mm;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .last-line {
        font-size: 3mm;
        padding: 5px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
      }
      .even-col {
        display: flex;
        flex-direction: row;
        justify-content:space-evenly;
        & > span {
          display: block;
          border-right: 1px solid #222;
          text-align: center;
          padding: 2.4mm 0;
          &:last-child {
            border-right: none;
          }
        }
      }
      .desc {
        font-size: 3mm !important;
        & > p {
          text-indent: 2em;
        }
      }
      table {
        // background: #666;
        border: 1.1mm solid #000;
        & > tr {
          // background: #fff;
          & > td {
            font-size: 3.6mm;
            &:not(.even-td){
              padding: 2.4mm 3.3mm;
            }
          }
        }
      }
    }
  }
}
</style>
